const main_data = {
    slug_module: "sub-categorias",
    key_interfaz: "tabla_sub_categorias",
    key_esquema: "SUBCATEGORIAS",
}

module.exports = {
    main_data
}